// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"fd3d5f60","171":"bfa874b0","641":"7624815c","735":"fcfcac28","820":"e9268408","875":"ea1c2da0","906":"eb8d734f"}[chunkId] + ".chunk.js";
};